import { Dialog } from 'primereact/dialog';
import React, { useEffect, useState } from 'react'
import { Button, Col, Row } from 'react-bootstrap';
import { IAppState } from 'model/IAppState';
import { useDispatch, useSelector } from 'react-redux';
import { enumCountryCode, enumDeliveryOptions } from 'helpers/enum';
import * as Uri from 'helpers/Uri';
import { isNil } from 'lodash';
import moment from 'moment';
import * as rdEnum from 'helpers/enum';
import * as orderModel from 'model/IOrder';
import * as bankInfoModel from 'model/IBankInfo';

const ArrangePayment = (props: any) => {

    const orderDetailsFromStore: orderModel.IOrderRequest | null = useSelector((state: IAppState) => {
        return state?.orderDetails;
    });
    const selectedDeliveryFromStore = useSelector((state: IAppState) => {
        return state.selectedDelivery;
    });


    const [dialogVisible, setDialogVisible] = useState(false);
    const { buttonText } = props;

    const onShowDialog = () => {
        setDialogVisible(true);
    }

    const onHideDialog = () => {
        setDialogVisible(false);
    }


    const [bankDetails, setBankDetails] = useState<bankInfoModel.IBankInfo>(rdEnum.enumAuBank);

    useEffect(() => {
        if (orderDetailsFromStore?.Country === rdEnum.enumCountryCode.NewZealand) {
            setBankDetails(rdEnum.enumNZBank);
        }
        else {
            setBankDetails(rdEnum.enumAuBank);
        }
    }, [orderDetailsFromStore?.Country]);


    var currencyFormatter = new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
    });

    const showPrice = (price: number | null | undefined) => {
        if (price != null) {
            return currencyFormatter.format(price);
        }
        return '';
    }


    return (
        <>
            <div className='pipeline-btn-panel'>
                <Button className='pipeline-btn'
                    onClick={() => onShowDialog()}
                >
                    {buttonText}
                </Button>
            </div>

            <Dialog className='order-details-dialog arrange-payment-dialog' visible={dialogVisible} position='bottom'
                style={{ maxWidth: '1100px' }} draggable={false} resizable={true} onHide={() => onHideDialog()}>
                <div className='arrange-payment-dialog-container'>
                <Row>
                    <Col className="container-title">ARRANGE PAYMENT</Col>
                </Row>
                <Row>
                    <Col className="container-desc desc1">HOW DO I PAY FOR MY CADILLAC?</Col>
                </Row>
                <Row>
                    <Col className="container-desc">Payment for your Cadillac is done via Electronic Funds Transfer (EFT), commonly known as a bank transfer.
                    You can start to make payments toward the total driveaway price of your vehicle now that it is confirmed status.
                    with the total balance due no later than 3 business days prior to instore collection, or for regional delivery customers,
                    prior to organising last mile transport from our store. Below is the information you'll need to arrange payment.
                        </Col>
                </Row>
                <Row>
                    <Col md={4} xs={12} className="arrange-payment-wrapper">
                        <div className='arrange-payment-section'>
                            <div className='section-title'>ORDER INFOMATION</div>

                            <div className='arrange-payment-item'>
                                <div className="title">Payment Reference</div>
                                <div className="data">{orderDetailsFromStore?.YanaOrderNo}</div>
                                <div className="desc">Please use your order number as a reference for all payments.</div>
                            </div>
                            <div className='arrange-payment-item'>
                                <div className="title">Total Outstanding</div>
                                <div className="data">{showPrice(orderDetailsFromStore?.Balance)}</div>
                                <div className="desc">This is the amount outstanding to be paid 3 business days prior to delivery. Note recent transactions can take up to 3 business days to be reflected here.</div>
                            </div>
                            <div className='arrange-payment-item'>
                                {
                                    (isNil(orderDetailsFromStore?.PaymentDueDate) || orderDetailsFromStore?.PaymentDueDate === "") ? (
                                        <>
                                            <div className="title">Due Date:</div>
                                            <div className="data">3 business days prior to delivery</div>
                                            <div className="desc">Full payment for your vehicle is due 3 business days prior to your delivery appointment. This date will update once your delivery is scheduled.</div>
                                        </>
                                    ) : (
                                            <>
                                                <div className="title">Due Date:</div>
                                                <div className="data">{moment(orderDetailsFromStore?.PaymentDueDate, "DD.MM.YYYY").format("dddd, DD MMMM YYYY")}</div>
                                                <div className="desc">Full payment for your vehicle is due 3 business days prior to your delivery appointment. Please allow extra time for transfer delays.</div>
                                            </>
                                        )
                                }
                            </div>
                        </div>
                    </Col>
                    <Col md={4} xs={12} className="arrange-payment-wrapper">
                        <div className='arrange-payment-section'>
                            <div className='section-title'>CADILLAC BANK DETAILS</div>

                            <div className='arrange-payment-item'>
                                <div className="title">Bank Name</div>
                                <div className="data">
                                    {bankDetails.BankName}
                                    {bankDetails.BankBranchName !== "" && (
                                        <>
                                            <br />
                                            {bankDetails.BankBranchName}
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className='arrange-payment-item'>
                                <div className="title">Account Name</div>
                                <div className="data">{bankDetails.AccountName}</div>
                                <div className="desc">Cadillac is a subsidiary of General Motors (GM). You will be making your payment to GM.</div>
                            </div>
                            <div className='arrange-payment-item'>
                                <div className="title">BSB Number</div>
                                <div className="data">{bankDetails.BSBNumber}</div>
                            </div>
                            <div className='arrange-payment-item'>
                                <div className="title">Account Number</div>
                                <div className="data">{bankDetails.AccountNumber}</div>
                            </div>
                            <div className='arrange-payment-item'>
                                <div className="title">Payment Reference</div>
                                <div className="data">{orderDetailsFromStore?.YanaOrderNo}</div>
                            </div>

                        </div>
                    </Col>
                    <Col md={4} xs={12} className="arrange-payment-wrapper">
                        <div className='arrange-payment-section'>
                            <div className='section-title'>GET SUPPORT</div>
                                <div className='section-desc'>We're here to help every step of the way. Please contact your Cadillac Sales Ambassador if you need support arranging your payment.</div>
                            <div className='arrange-payment-item'>
                                {
                                    orderDetailsFromStore?.Country === rdEnum.enumCountryCode.NewZealand ? (
                                        <div className='arrange-payment-item'>
                                            <div className="title">Cadillac New Zealand</div>
                                            <div className="data">{bankDetails.Phone}</div>
                                        </div>
                                    ) : (
                                            <div className='arrange-payment-item'>
                                                <div className="title">Cadillac Australia</div>
                                                <div className="data">{bankDetails.Phone}</div>
                                            </div>
                                        )
                                }
                            </div>
                        </div>
                    </Col>
                    </Row>
                </div>
            </Dialog>
        </>
    )
}

export default ArrangePayment